import { events } from '../mocks/dashboard';

/**
 * Cockpit live-activity source (cutover §3 honesty fix).
 *
 * The sample events are the ONLY source today — the platform has no event
 * stream yet (Console's SSE route is unregistered; no WS transport). The old
 * implementation hardcoded `isConnected: true`, which presented sample data
 * as a live feed ("Streaming now" + pulsing dot over mock rows). That is a
 * fabricated-live violation, fixed by reporting the truth:
 *   - events: the sample seed (EventFeed renders it behind its sample badge)
 *   - isConnected: FALSE — there is no stream, so the UI must never claim one
 *
 * When a real feed lands (B7 transport or the Console SSE source), this hook
 * is the single attach point: replace `events` with the stream buffer and
 * flip `isConnected` from the transport's status.
 */
function useEventStream() {
  return {
    events,
    isConnected: false
  };
}

export default useEventStream;
